<template>
  <div class="Sobre">
    <head-nav :activeNav="'Sobre'"></head-nav>
    <div class="container">
      <h1>「 SOBRE NOSOTROS 」</h1>
      <p>
        Muchamo es una aplicación de préstamos de crédito en línea en Perú. ¡Si
        necesitan un préstamo con urgencia,si quieren un préstamo más sólido, si
        desean un préstamo con monto más alto, utiliza Muchamo! El depósito
        llega muy rápido menos de 3 minutos. La aplicación Muchamo es segura,
        fácil y flexible. ¡Utiliza Muchamo, les dará una experiencia mágica!
      </p>
    </div>
    <div class="main_margin">
      <div class="left">
        <h2>Contáctanos</h2>
        <h3>
          ¡Si tiene más dudas, conversa con nosotros sin compromiso, le
          responderemos con prontitud para que esté satisfecho en todo momento!
        </h3>
        <div class="info">
          <div style="margin-right: 73px">
            <div class="left">
              <img src="../assets/image/Inicio/necesitas_one.png" alt="" />
              <div>
                <h5>Atención al Cliente:</h5>
                <h6>+51 {{ phone }}</h6>
              </div>
            </div>
            <div class="left">
              <img src="../assets/image/Inicio/necesitas_three.png" alt="" />
              <div>
                <h5>Email:</h5>
                <h6>{{ email }}</h6>
                <!-- <h6>support@muchamo.com</h6> -->
              </div>
            </div>
          </div>
          <div>
            <div class="left">
              <img src="../assets/image/Inicio/necesitas_two.png" alt="" />
              <div>
                <h5>WhatsApp:</h5>
                <h6>+51 {{ whatsApp }}</h6>
              </div>
            </div>
            <div class="left">
              <img src="../assets/image/Inicio/necesitas_four.png" alt="" />
              <div>
                <h5>Horario de Atención:</h5>
                <h6>
                  {{ daySection[0] }} <br />
                  {{ daySection[1] || "" }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="../assets/image/Sobre/one.png" alt="" class="one_img" />
    </div>
    <foot-page></foot-page>
  </div>
</template>

<script>
import headNav from "../components/headNav.vue";
import footPage from "../components/footPage.vue";

export default {
  name: "Sobre",
  components: {
    headNav,
    footPage,
  },
  data() {
    return {
      whatsApp: "",
      phone: "",
      email: "",
      daySection: [],
    };
  },
  created() {
    this.getInformation();
  },
  mounted() {},
  methods: {
    getInformation() {
      if (localStorage.getItem("customerData") !== "undefined") {
        const data = JSON.parse(localStorage.getItem("customerData"));
        this.whatsApp = data.customerServiceWhatsApp.whatsApp;
        this.phone = data.customerServicePhone.phone;
        this.email = data.customerServiceEmail.email;
        this.daySection = data.customerServiceWorkTimeInfo.daySection.split(
          ","
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Sobre {
  width: 100%;
  height: auto;
  background: #03040c;
  .container {
    width: 1200px;
    margin: 0 auto;
    h1 {
      font-size: 52px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;

      color: #e8e8e9;
      margin-bottom: 40px;
      margin-top: 66px;
    }
    p {
      font-size: 35px;
      font-family: LucidaGrande-Bold, LucidaGrande;
      font-weight: bold;

      color: #e8e8e9;
      line-height: 45px;
      margin-bottom: 85px;
    }
  }
  .main_margin {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding-bottom: 0.7rem;
    .left {
      h2 {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #6b4add;
        margin-bottom: 18px;
      }
      h3 {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;

        color: #e8e8e9;
        margin-bottom: 62px;
      }
      .info {
        display: flex;
        font-family: MicrosoftYaHei;

        color: #e8e8e9;
        .left {
          display: flex;
          align-items: flex-start;
          margin-bottom: 50px;
          img {
            width: 86px;
          }
          div {
            margin-top: 15px;
            h5 {
              font-size: 22px;
            }
            h6 {
              font-size: 20px;
              margin-top: 7px;
            }
          }
        }
      }
    }
    .one_img {
      width: 423px;
      height: 435px;
      margin-top: 35px;
    }
  }
}
</style>
